class VgFormsNonce {
	vgApiClient = new VgApiClient(VgHelpers.getCountry(), VgHelpers.getLanguage());

	async isValidNonce(nonceFieldName, action) {
		const nonce = document.querySelector(`input[name="${nonceFieldName}"]`)?.value;
		if (!nonce) return false;

		try {
			return await this.vgApiClient.validateNonce(nonce, action);
		} catch (error) {
			return false;
		}
	}

	async fetchAndSetNonce(action, nonceFieldName) {
		const nonceValue = await this.vgApiClient.getFormNonce(action);
		const nonceInput = document.querySelector(`input[name="${nonceFieldName}"]`);
		if (nonceInput) {
			nonceInput.value = nonceValue;
		}
	}

}
